import { lighten } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
	red,
	green,
	blueGrey,
	deepPurple,
	yellow,
	purple,
	teal,
	indigo,
	blue,
	orange, lightBlue
} from "@mui/material/colors";


export const TableStyle = makeStyles((theme) => ({
	tableContainer: {
		/*backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255, 0.4)" : "rgba(0, 0, 0, 0.3)",
		 borderRadius: "20px",*/
	},
	table: {
		/*minWidth: 1000 tolta al07/06/2021*/
	},
	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1,
	},
	row: {
		cursor: "pointer",
	},
	root: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	positivo: {
		backgroundColor: red[500],
		color: "#FFF",
	},
	negativo: {
		backgroundColor: green[600],
		color: "#FFF",
	},
	esitoIcon: {
		color: "#FFF"
	},
	chipText: {
		color: red[600],
	},
	numTamponiText: {
		fontSize: 20
	},
	toolbarRoot: {
		borderRadius: "4px",
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},
	highlight:
		theme.palette.mode === 'light'
			? {
				color: theme.palette.secondary.main,
				backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			}
			: {
				color: theme.palette.text.primary,
				backgroundColor: theme.palette.secondary.dark,
			},
	title: {
		flex: '1 1 100%',
		color: theme.palette.mode === 'light' ? theme.palette.secondary.dark : "#FFF"
	},
	titleNoColor: {
		flex: '1 1 100%',
	},
	/*red: {
	 backgroundColor: red[500],
	 //width: theme.spacing(3),
	 //height: theme.spacing(3),
	 //margin: "auto",
	 },
	 orange: {
	 backgroundColor: orange[500],
	 //width: theme.spacing(3),
	 //height: theme.spacing(3),
	 //margin: "auto",
	 },
	 green: {
	 backgroundColor: green[500],
	 //width: theme.spacing(3),
	 //height: theme.spacing(3),
	 //margin: "auto",
	 },*/
	red: {
		color: "#FFF",
		backgroundColor: red[500],
		padding: theme.spacing(2),
		width: 130
	},
	orange: {
		color: "#FFF",
		backgroundColor: orange[500],
		padding: theme.spacing(2),
		width: 130
	},
	green: {
		color: "#FFF",
		backgroundColor: green[500],
		padding: theme.spacing(2),
		width: 130
	},
	deepPurple: {
		color: "#FFF",
		backgroundColor: deepPurple[500],
		padding: theme.spacing(2),
		width: 130
	},
	greenDark: {
		color: "#FFF",
		backgroundColor: green[700],
		padding: theme.spacing(2),
		width: 130
	},
	blue: {
		color: "#FFF",
		backgroundColor: blue[500],
		padding: theme.spacing(2),
		width: 130
	},
	indigo: {
		color: "#FFF",
		backgroundColor: indigo[500],
		padding: theme.spacing(2),
		width: 130
	},
	teal: {
		color: "#FFF",
		backgroundColor: teal[500],
		padding: theme.spacing(2),
		width: 130
	},
	purple: {
		color: "#FFF",
		backgroundColor: purple[500],
		padding: theme.spacing(2),
		width: 130
	},
	yellow: {
		color: "#FFF",
		backgroundColor: yellow[500],
		padding: theme.spacing(2),
		width: 130
	},
	/*deepPurple: {
	 backgroundColor: deepPurple[500],
	 //width: theme.spacing(3),
	 //height: theme.spacing(3),
	 //margin: "auto",
	 },*/
	errorChip: {
		color: "#FFF",
		backgroundColor: blueGrey[800],
		padding: theme.spacing(2),
		width: 130
	},
	cell: {
		//borderBottom: "1px solid rgba(0,0,0,0.1)",
	},
	emptyCell: {
		//border: "none",
	},
	emptyCellText: {
		/*width: "100%",
		 textAlign: "center"*/
	},
	info: {
		padding: theme.spacing(2),
	},
	notVisibleRow: {
		display: "none",
	},
	removeOnHover: {
		display: "table-cell"
	},
	notVisibleRowInUso: {
		display: "none",
		border: "none",
	},
	notVisibleRowCallReq: {
		display: "none",
		border: "none",
	},
	rispostaUtenteRow: {
		backgroundColor: theme.palette.mode === "light" ? lightBlue[100] : lightBlue[800],
	},
	rowOnOver: {
		transition: "transform .1s",
		height: 65,
		"&:hover": {
			"& $notVisibleRow": {
				display: "table-cell",
			},
			"& $removeOnHover": {
				display: "none",
			},
		},
	},
	inUsoRow: {
		backgroundColor: theme.palette.mode === "light" ? red[100] : red[800],
		"& $notVisibleRowInUso": {
			display: "table-cell",
		},
		"& $removeOnHover": {
			display: "none",
		},
	},
	callRequest: {
		backgroundColor: theme.palette.mode === "light" ? orange[100] : orange[800],
		"& $notVisibleRowCallReq": {
			display: "table-cell",
		},
		"& $removeOnHover": {
			display: "none",
		},
	}
}));
